<template>
  <transition name="infomodal">
    <div class="modal-mask fixed top-0 left-0 w-full h-full outline-none fade">
      <div
        class="modal-container w-2/3 mt-12 mb-10 mx-auto rounded-lg shadow-lg z-50 h-80p bg-white"
      >
        <header
          class="h-20 pt-6 border-b border-gray-200 border-solid w-11/12 mx-auto flex justify-between"
        >
          <h1 class="text-gray-600 font-bold text-3xl">School Admin Teacher</h1>
          <i
            class="fas fa-times-circle cursor-pointer items-center mt-0 rounded-2 text-black text-4xl z-50"
            @click="$emit('close')"
            style="right: -12px"
          ></i>
        </header>
        <div class="h-screen overflow-y-auto w-11/12 mx-auto section-content">
          <slot name="body">
            <section v-if="errored" class="w-full text-center mt-6">
      <h3 class="font-bold text-xl text-action-red">
        There was an issue adding the teacher details.
      </h3>
      <p class="text-action-blue">
        Please try again shortly or contact us to resolve the issue.
      </p>
    </section>

            <section v-if="isComplete" class="w-full text-left my-10">
              <h3 class="font-bold text-xl ">Thank you. The School Admin has now been set. </h3>
              <p class="instruction text-sm">The designated school admin will now has the additional features on their next login. 
                The school admin can be changed in the future or if teachers within your organisation move.</p>
              <button
                @click="$emit('close')"
                type="button"
                class="publish-button hover:bg-blue-300 mt-4"
              >
               Close Window
              </button>
            </section>


            <div v-if="!isComplete" class="instruction pt-4 pb-12 text-sm">
              <p>
                It appears that you do not have a nominated
                <strong>'School Admin'</strong> amongst the school teachers who
                currently have access to the PE Passport platform.
              </p>
              <p class="pt-2">
                We have added the new <strong>'School Admin'</strong> feature in
                order to provide a point of contact for any platform changes but
                also has to allow the admin to have enhanced functionality
                within the platform in order to perform School system based
                tasks. <br />
                These include tasks such as
                <strong
                  >adding new teachers or controlling the yearly planning grid
                  changes.</strong
                >
              </p>
              <p class="pt-2">
                The school admin can be changed subsequently but in the first
                instance can you please select an appropriate school admin from
                the teacher access details below or if preferred 
                <a href="https://primarypepassport.co.uk/faq/" target="_blank"
                 class="font-bold text-blue-400">contact us to request a new
                teacher login</a> who will perform this role.
              </p>

              <div class="overflow-y-auto mt-6">
                <table
                  class="table-wrapper w-95p bg-white mx-auto rounded shadow-sm"
                >
                <thead class="bg-gray-100 w-full">
                 <tr>
                  <th class="text-left p-2">Teacher</th>
                  <th>Set Admin</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in teachers" :key="user.identifier">
                      <td class="w-3/12">{{ user.name }}</td>
                      <td
                        width="10%"
                        class="text-center text-xs cursor-pointer text-blue-400"
                      >
                        <button
                          @click="selectUserAdmin(user)"
                          type="button"
                          class="cursor-pointer hover:opacity-50 wide focus:outline-none"
                        >
                          <i
                          class="text-2xl"
                            v-bind:class="[
                              inSelected(user)
                                ? 'fas fa-check-circle text-green-400'
                                : ' far fa-circle text-gray-300',
                            ]"
                          ></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </slot>
          <footer class="h-24 border-t border-gray-200 border-solid"></footer>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

import { SchoolService } from "@/services/school.service";
import { teacherTypeMixin } from "@/mixins/teacherTypeMixin.js";


export default {
  name: "infomodal",
  mixins: [teacherTypeMixin],
  props: {
    teachers: { type: Array, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
  },
  data() {
    return {
      teacher: {},
      isComplete: false,
      errored: false
    };
  },
  methods: {
    selectUserAdmin(user, time = 500) {
      this.teacher = user;
      let vm = this;
      clearTimeout(vm.timeout);
        vm.timeout = setTimeout(() => {
          vm.updateUser()
        }, time);
    },
    updateUser() {
      this.teacher.is_admin = true
        SchoolService.update("users", this.teacher.identifier, this.teacher)
        .then((response) => this.completion(true))
        .catch((err) => {
          this.failure(err);
        });
    },
    inSelected(user) {
      return this.teacher.identifier === user.identifier;
    },
    completion(val) {
      this.$store
      .dispatch("setAdmin", true )
      .catch((err) => console.log("Admin EOROR", err));

      this.currentUser.setAdmin(true)

      this.isComplete = true;
    },
    failure(error) {
      this.isComplete = false;
      this.errored = true;
      console.log("teacher update error " + error);
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
